import { useEffect, useState } from "react";

import CompanyAPI from "../../company/CompanyAPI";
import Form from "react-bootstrap/Form";
import HallAppToast from "../../../commons/HallAppToast";
import ModalTime from "./ModalTime";
import SchedulerConfigAPI from "../SchedulerConfigAPI";

function Weeks({ weekConfig,employeeId,fetchAll }) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModalTime, setShowModalTime] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const defaultStartTimeMorning = "09:00";
  const defaultEndTimeMorning = "12:00";
  const defaultStartTimeAfternoon = "13:00";
  const defaultEndTimeAfternoon = "18:00";

  const companyAPI = new CompanyAPI();
  const schedulerAPI = new SchedulerConfigAPI();

  const handleToggle = async (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);

    if (checked) {
      const dataCreate = {
        companyId: companyAPI.getCompanyManagment().id,
        employeeId: employeeId,
        dayOfWeek: weekConfig.dayOfWeek,
        endTimeAfternoon: defaultEndTimeAfternoon,
        endTimeMorning: defaultEndTimeMorning,
        startTimeAfternoon: defaultStartTimeAfternoon,
        startTimeMorning: defaultStartTimeMorning,
      };

      try {
        setLoading(true);
        await schedulerAPI.configWeeklySchedule(dataCreate);
        HallAppToast.success();
      
      } catch (_) {
        HallAppToast.genericError();
        setIsChecked(false); // rollback visual
      } finally {
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        await schedulerAPI.deleteConfigWeeklySchedule(
          companyAPI.getCompanyManagment().id,
          weekConfig.dayOfWeek,
          employeeId
        );
        HallAppToast.success();
      } catch (_) {
        HallAppToast.genericError();
        setIsChecked(true); // rollback visual
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setIsChecked(weekConfig.isActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getWeekConfigText() {
    const { startTimeMorning, endTimeMorning, startTimeAfternoon, endTimeAfternoon } = weekConfig || {};

    if (startTimeMorning && endTimeMorning && startTimeAfternoon && endTimeAfternoon) {
      return `${startTimeMorning} às ${endTimeMorning} • ${startTimeAfternoon} às ${endTimeAfternoon}`;
    }

    if (startTimeMorning && endTimeMorning) {
      return `${startTimeMorning} às ${endTimeMorning}`;
    }

    if (startTimeAfternoon && endTimeAfternoon) {
      return `${startTimeAfternoon} às ${endTimeAfternoon}`;
    }

    return `${defaultStartTimeMorning} às ${defaultEndTimeMorning} • ${defaultStartTimeAfternoon} às ${defaultEndTimeAfternoon}`;
  }

  const timeText = getWeekConfigText();

  return (
    <>
      <div className={`ha-weekCard ${isChecked ? "is-on" : "is-off"}`}>
        <div className="ha-weekCard__left">
          <div className="ha-weekCard__title">{weekConfig.description}</div>

          {isChecked ? (
            <button
              type="button"
              className="ha-weekCard__timePill"
              disabled={isLoading}
              onClick={() => setShowModalTime(true)}
              title="Editar horários"
            >
              <i className="bi bi-clock" />
              <span>{timeText}</span>
              <i className="bi bi-chevron-right" />
            </button>
          ) : (
            <div className="ha-weekCard__hint">Desativado — ative para configurar horários.</div>
          )}
        </div>

        <div className="ha-weekCard__right">
          <Form.Check
            disabled={isLoading}
            checked={isChecked}
            type="switch"
            id={`week-${weekConfig.dayOfWeek}`}
            label=""
            value={weekConfig.dayOfWeek}
            onChange={handleToggle}
            className="ha-weekCard__switch"
          />
          {isLoading && <div className="ha-weekCard__saving">Salvando...</div>}
        </div>
      </div>

      <ModalTime fetchAll={fetchAll} show={showModalTime} weekConfig={weekConfig} closeShow={() => setShowModalTime(false)} employeeId={employeeId}/>
    </>
  );
}

export default Weeks;
